module.exports = __webpack_public_path__ + "static/media/Policeman.5a3b2526.jpg";